import {styled} from '@mui/material';

const StyledCardCodeField = styled('div')`
	display: flex;
	align-items: stretch;
	width: 100%;
	overflow: hidden;
	border: 1px solid #ebebeb;
	border-radius: 12px;
	background-color: ${({theme}) => theme.palette.common.white};
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
`;

const StyledCardCodeValue = styled('span')`
	flex: 1;
	min-width: 0;
	padding: 6px 10px 6px 12px;
	border-right: 1px solid #ebebeb;
	color: ${({theme}) => theme.palette.text.primary};
	font-size: 18px;
	line-height: 28px;
	word-break: break-word;
`;

const StyledCopyButton = styled('button')`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 10px;
	border: 0;
	background: transparent;
	color: ${({theme}) => theme.palette.text.primary};
	cursor: pointer;
`;

export {StyledCardCodeField, StyledCardCodeValue, StyledCopyButton};
